"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const PlusIcon = (props) => {
    return (react_1.default.createElement(core_1.SvgIcon, Object.assign({}, props),
        react_1.default.createElement("g", { id: "Group_630", "data-name": "Group 630", transform: "translate(-1087 -172)" },
            react_1.default.createElement("g", { id: "Group_629", "data-name": "Group 629", transform: "translate(-8 -29.729)" },
                react_1.default.createElement("rect", { id: "Rectangle_182", "data-name": "Rectangle 182", width: "2", height: "12", rx: "1", transform: "translate(1100 201.729)", fill: "#2ea0dc" }),
                react_1.default.createElement("rect", { id: "Rectangle_183", "data-name": "Rectangle 183", width: "2", height: "12", rx: "1", transform: "translate(1107 206.729) rotate(90)", fill: "#2ea0dc" })))));
};
exports.default = PlusIcon;
